(function () {
  var sections = document.querySelectorAll("[data-scroll-play-video]");
  if (!sections.length) return;

  var playVisibleVideos = function (section, shouldPlay) {
    var videos = section.querySelectorAll(".p-detachable-panel__bg-video");
    videos.forEach(function (video) {
      var isVisible = window.getComputedStyle(video).display !== "none";
      if (!isVisible) {
        video.pause();
        return;
      }

      if (shouldPlay) {
        video.muted = true;
        var promise = video.play();
        if (promise && typeof promise.catch === "function") {
          promise.catch(function () {});
        }
      } else {
        video.pause();
      }
    });
  };

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        playVisibleVideos(entry.target, entry.isIntersecting);
      });
    },
    { threshold: 0.35 }
  );

  sections.forEach(function (section) {
    playVisibleVideos(section, false);
    observer.observe(section);
  });
})();
